/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import Relay from 'react-relay';
import Expression from '../../../../expression/Expression.react';
import ExpressionGroup from '../../../../expression/ExpressionGroup.react';
import { Form } from 'formsy-react-components';
import LoadingButton from '../../../../fw/LoadingButton.react';
import config from '../../../../../common/config';
import {safeJSONparse} from "../../../../../common/util/safeJSONparse";

export const messages = defineMessages({
    url: {id: 'IFrameEdit.url', 'defaultMessage': 'URL:'},
    urlDescription: {id: 'IFrameEdit.urlDescription', 'defaultMessage': 'URL must start with https://. Unsecure connections will not work in most applications.'},
    height: {id: 'IFrameEdit.height', 'defaultMessage': 'Height in pixels:'},
    heightDescription: {id: 'IFrameEdit.heightDescription', 'defaultMessage': 'Keep empty for dynamic height according to {productName} panel height.'},
    save: {id: 'IFrameEdit.save', 'defaultMessage': 'Save Addon configuration'},
});

export const handlerName = "iframe";

class IFrameEdit extends React.Component {

    static propTypes = {
        channelAddon: PropTypes.object.isRequired,
        intl: PropTypes.object,
        save: PropTypes.func,
    };

    constructor(props) {
        super(props);

        let channelAddon = this.props.channelAddon;
        let isOk = true;
        let options = safeJSONparse(channelAddon.options);

        for (let row of Object.keys(options)) {
            if (!options[row]) {
                isOk = false;
            }
        }

        this.state = {
            canSubmit: isOk,
            mapping: options,
        };
    }

    possibleVariableGroups = () => {
        return ([{
            id: "",
            name: ""
        }]);
    };

    possibleVariables = (group) => {
        if (group.id === "") {
            let channelAddon = this.props.channelAddon;

            return channelAddon.sourceDef.channelEntityDefs.edges[0].node.usedFieldDefs.edges.map(({node}) => node);
        }
    };

    enableButton = () => {
        this.setState({
            canSubmit: true
        });
    };

    disableButton = () => {
        this.setState({
            canSubmit: false
        });
    };

    add = () => {
        return this.props.save(this.state.mapping);
    };

    collectMappableFields() {
        return [
            {
                key: 'url',
                name: this.props.intl.formatMessage(messages.url),
                description: this.props.intl.formatMessage(messages.urlDescription),
            },
            {
                key: 'height',
                name: this.props.intl.formatMessage(messages.height),
                description: this.props.intl.formatMessage(messages.heightDescription, {productName: config.PRODUCT_NAME}),
            }
        ];
    }

    render() {
        return (<Form
            onInvalid={this.disableButton}
            onValid={this.enableButton}
            onValidSubmit={this.add}
        >

            <ExpressionGroup possibleVariableGroups={this.possibleVariableGroups} possibleVariables={this.possibleVariables}>
                <table className="table">
                    <tbody>
                    {this.collectMappableFields().map((row) => {
                        return (
                            <tr key={row.key}>
                                <td>{row.name}</td>
                                <td><Expression afterChange={(value) => {
                                    let newMapping = {...this.state.mapping};
                                    newMapping[row.key] = value;

                                    this.setState({
                                        mapping: newMapping,
                                    });

                                }} expression={this.state.mapping[row.key]}/>{row.description ? <p><small>{row.description}</small></p> : null}</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </ExpressionGroup>

            <LoadingButton className="btn btn-primary"
                           disabled={!this.state.canSubmit}
                           type="submit">{this.props.intl.formatMessage(messages.save)}</LoadingButton>
        </Form>);
    }
}

export default Relay.createContainer(injectIntl(IFrameEdit), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        channelAddon: () => {
            return Relay.QL`
                fragment on ChannelAddon {
                    id,
                    realId,
                    name,
                    options,
                    channel {
                        id,
                        name,
                        organisation_id,
                    },
                    sourceDef {
                        id,
                        channelEntityDefs(first: 100) {
                            edges {
                                node {
                                    id,
                                    usedFieldDefs(first: 1000) {
                                        edges {
                                            node {
                                                id,
                                                realId,
                                                name,
                                                key,
                                                type,
                                                entityDef {
                                                    id,
                                                    key,
                                                    name
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }`;
        }
    }
});
